/* src/app/_shared/components/button/button.component.scss */
:host {
  display: block;
  --width: auto;
  --height: auto;
  --padding: var(--space);
  --icon-margin: 7px;
  --active-background-color: #6da4f3;
  --background-color: var(--ion-color-primary);
  --text-color: var(--ion-color-primary-contrast);
  --font-size: 14px;
}
:host[expanded] {
  --width: 100%;
}
:host[expanded] button {
  --width: 100%;
}
:host[icon] {
  --padding: calc(var(--space-top) / 2) var(--space-right) calc(var(--space-bottom) / 2) var(--space-left);
}
:host[size=large] {
  --padding: calc(var(--space-top) * 1.5) var(--space-right) calc(var(--space-bottom) * 1.5) var(--space-left);
  --font-size: 16px;
}
.flow-button {
  width: var(--width);
  height: var(--height);
}
.flow-button button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: row nowrap;
  width: var(--width);
  height: var(--height);
  padding: var(--padding);
  background-color: var(--background-color);
  border-radius: var(--radius);
  color: var(--text-color);
  font-size: var(--font-size);
  font-weight: inherit;
  transition: background-color 0.1s;
}
.flow-button button.active {
  background-color: var(--active-background-color);
  outline: none;
}
.flow-button button:disabled {
  background-color: var(--disabled-background);
  color: var(--disabled-text);
}
.flow-button ion-icon {
  margin-right: var(--icon-margin);
  color: var(--text-color);
  font-size: var(--icon-size);
}
/*# sourceMappingURL=button.component.css.map */
